module.exports = __webpack_public_path__ + "img/plano.9e35d51d.png";